import { nomePessoa } from '../nucleo/formato';

/**
 * Caixas de seleção de um grupo (papéis, pessoas, destinatários): o padrão das listas de membros do sistema, usado no
 * relatório salvo (`modules/relatorios/salvos.tsx`) e no "Compartilhar com" das visões da `Tabela` (`compartilhar-visao.tsx`).
 * Review r37 visual (B1): o grupo é um `fieldset` com `legend` (o `label for` apontava para o `<ul>`, que não é rotulável, e
 * o leitor de tela não dizia o nome do grupo). Review r38 (SPEC-B2, VIS-B1): a cópia das visões repetia o defeito; agora as
 * duas telas usam este. Review r38 spec (M1): `pessoas` passa o nome por `nomePessoa` (modo discreto; o e-mail usado como
 * nome de quem foi convidado sem nome não aparece inteiro).
 */
export function Caixas({
  id,
  rotulo,
  itens,
  valor,
  aoMudar,
  pessoas = false,
}: {
  id: string;
  rotulo: string;
  itens: { id: string; nome: string }[];
  valor: string[];
  aoMudar: (v: string[]) => void;
  pessoas?: boolean;
}) {
  return (
    <fieldset className="flex min-w-0 flex-col">
      <legend className="mb-1.5 text-sm font-medium text-tinta-2">{rotulo}</legend>
      <ul id={id} className="max-h-48 divide-y divide-borda overflow-y-auto rounded-lg border border-borda bg-sup-2">
        {itens.map((m) => {
          const nome = pessoas ? nomePessoa(m.nome) : m.nome;
          return (
            <li key={m.id}>
              <label className="flex cursor-pointer items-center gap-3 px-3 py-2 text-sm">
                <input type="checkbox" checked={valor.includes(m.id)} onChange={(e) => aoMudar(e.target.checked ? [...valor, m.id] : valor.filter((x) => x !== m.id))} className="size-4 accent-acento" />
                <span className="min-w-0 truncate" title={nome}>
                  {nome}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
